import React from 'react';

const Pagination = ({ currentPage, totalPages, setCurrentPage }) => {
  const renderPagination = () => {
    const pages = [];
    const maxPagesToShow = 10;
    const startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => setCurrentPage(i)}
          className={`p-2 border border-[#632af8] rounded ${currentPage === i ? 'bg-black text-[#00f6ff]' : 'bg-black text-[#632af8]'} mx-1 hover:bg-[#000000] hover:text-[#00f6ff]`}
          >
          {i}
        </button>
      );
    }

    return pages;
  };

  return (
    <div className="flex flex-col items-center mt-4">
      <div className="flex justify-center items-center mb-2">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          className="p-2 border border-[#632af8] rounded bg-[#000000] text-[#00f6ff] hover:bg-transparent hover:text-[#632af8]"
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          className="p-2 border border-[#632af8] rounded bg-[#000000] text-[#00f6ff] hover:bg-transparent hover:text-[#632af8]"
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
      <span className="text-[#00f6ff]">Page {currentPage} of {totalPages}</span>
    </div>
  );
};

export default Pagination;
